import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
	connect() {
		this.element.addEventListener("trix-file-accept", this.restrictAttachments);
	}

	restrictAttachments(event) {
		const acceptedTypes = ["image/jpeg", "image/png"];
		if (!acceptedTypes.includes(event.file.type)) {
			event.preventDefault();
			alert("Only JPG and PNG images are allowed.");
		}
	}
}
